import { basePathApi } from "./basePathApi";
export const baseUrl = basePathApi;
